import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { htmlLegendPlugin } from './LegendConfig';
import { isDeveloperMode } from '../../../../../mock/developer.utils';

const iconList = [
  {
    id: 'Storage',
    icon: 'Royal-Ahrend-icon-of-organising-on-white-background',
  },
  {
    id: 'Qabin',
    icon: 'Royal-Ahrend-icon-of-space-in-space-on-white-background',
  },
  {
    id: 'Other',
    icon: 'Royal-Ahrend-icon-of-space-in-space-on-white-background',
  },
  { id: 'Office Desks', icon: 'Royal-Ahrend-icon-of-desk-on-white-background' },
  {
    id: 'Office Chairs',
    icon: 'Royal-Ahrend-icon-of-desk-chair-on-white-background',
  },
  {
    id: '3rd Party',
    icon: 'Royal-Ahrend-icon-of-space-in-space-on-white-background',
  },
];

const monthList = [
  'JAN.',
  'FEB.',
  'MAR.',
  'APR.',
  'MAY.',
  'JUN.',
  'JUL.',
  'AUG.',
  'SEP.',
  'OCT.',
  'NOV.',
  'DEC.',
];

const chartDataModel = {
  label: '',
  year: null,
  orderQuantityForNewKg: 0, // <= update this
  orderQuantityForRevivedKg: 0, // <= update this
  newKg: 0, // <= update this
  tooltipDataNew: [],
  revivedKg: 0, // <= update this
  tooltipDataRevived: [],
};

class ChartNewRevived {
  constructor(element, options) {
    this._element = element;
    this._options = options;

    this._chartTitleCategory = options.titleCategory || 'Categorie';
    this._chartTitlePeriod = options.titlePeriod || 'Periode';
    this._apiEndpoint = options.apiEndpoint;
    this._language = options.language;
    this._showByCategory = options.showByCategory === 'true' || false;

    this._selectedYearSet = [];

    this._cacheSelectors();
    this._init();
    void this._createEmissionChart();
  }

  _cacheSelectors() {
    const element = this._element;
    let error = false;

    // Note: wrappers
    this._yearButtonWrapper = element.querySelector('[data-arl-id="year-button-wrapper"]');
    this._messageWrapper = element.querySelector('[data-arl-id="message-wrapper"]');
    if (!this._yearButtonWrapper || !this._messageWrapper) {
      console.warn(`wrappers within the DOM invalid`);
      error = true;
    }

    // Note: Category
    this._chartCategory = element.querySelector('[data-arl-id="chart-canvas-category"]');
    this._legendCategory = element.querySelector('[data-arl-id="chart-legend-category"]');
    this._btnCategory = element.querySelector('[data-arl-id="chart-button-category"]');
    if (!this._chartCategory || !this._legendCategory || !this._btnCategory) {
      console.warn(`category-chart DOM invalid`);
      error = true;
    }
    // Note: Period
    this._chartPeriod = element.querySelector('[data-arl-id="chart-canvas-period"]');
    this._legendPeriod = element.querySelector('[data-arl-id="chart-legend-period"]');
    this._btnPeriod = element.querySelector('[data-arl-id="chart-button-period"]');
    if (!this._chartPeriod || !this._legendPeriod || !this._btnPeriod) {
      console.warn(`period-chart DOM invalid`);
      error = true;
    }

    this._chartYearValue = element.querySelector('[data-arl-id="chart-year-value"]');
    this._chartTotalValue = element.querySelector('[data-arl-id="chart-total-value"]');
    this._chartTitleValue = element.querySelector('[data-arl-id="chart-title-value"]');
    if (!this._chartYearValue || !this._chartTotalValue || !this._chartTitleValue) {
      console.warn(`chart value DOM invalid`);
      error = true;
    }

    if (error) {
      this._showMessage(true, `Er is iets fout gegaan!`);
      throw new Error(`chart error DOM invalid`);
    }
  }

  _init() {
    this._btnCategory.addEventListener('click', (e) => {
      this._showByCategory = true;

      this._btnCategory.classList.add('active');
      this._btnPeriod.classList.remove('active');

      this._chartCategory.style.display = 'block';
      this._legendCategory.style.display = 'block';
      this._chartPeriod.style.display = 'none';
      this._legendPeriod.style.display = 'none';

      this._rebuildSelectedChart();
    });

    this._btnPeriod.addEventListener('click', (e) => {
      this._showByCategory = false;

      this._btnPeriod.classList.add('active');
      this._btnCategory.classList.remove('active');

      this._chartPeriod.style.display = 'block';
      this._legendPeriod.style.display = 'block';
      this._chartCategory.style.display = 'none';
      this._legendCategory.style.display = 'none';

      this._rebuildSelectedChart();
    });
  }

  _rebuildSelectedChart() {
    if (this._showByCategory) {
      this._chartTitleValue.innerHTML = this._chartTitleCategory;
      if (this._chart1) {
        this._chart1.destroy();
      }
      this._createDataResultCategory(this._emissionsByType);
      this._initChartCategory(this._chartCategory, this._dataResultCategory);
      this._chartCategory.style.display = 'block';
    } else {
      this._chartTitleValue.innerHTML = this._chartTitlePeriod;
      if (this._chart2) {
        this._chart2.destroy();
      }
      this._createDataResultPeriod(this._emissionsByDate);
      this._initChartPeriod(this._chartPeriod, this._dataResultPeriod);
      this._chartPeriod.style.display = 'block';
    }
  }

  _mergeDataTooltip(tooltipData) {
    const tmpTooltipList = [];
    if (!tooltipData.length) {
      return tmpTooltipList;
    }

    tooltipData.forEach((tooltip) => {
      let tmpTooltip = tmpTooltipList.find((t) => t.label === tooltip.label);
      if (!tmpTooltip) {
        tmpTooltip = tooltip;
        tmpTooltipList.push(tmpTooltip);
      } else {
        tmpTooltip.kg += tooltip.kg;
        tmpTooltip.count += tooltip.count;
      }
    });

    return tmpTooltipList;
  }

  _mergeData(data) {
    const dataCopy = [...data];

    let filteredData = [];

    if (this._selectedYearSet.length === 1) {
      const selectedYear = this._selectedYearSet[0];
      filteredData = dataCopy.filter((x) => {
        return x.year === selectedYear;
      });
    } else if (this._selectedYearSet.length > 1) {
      this._selectedYearSet.forEach((year) => {
        const completeYearList = dataCopy.filter((x) => {
          return x.year === year;
        });
        const tooltipDataNewList = [];
        const tooltipDataRevivedList = [];
        const newModel = { ...chartDataModel };

        completeYearList.forEach((completeYear) => {
          newModel.label = year.toString(); // Note: must be a string!
          newModel.year = year;
          newModel.orderQuantityForNewKg += completeYear.orderQuantityForNewKg;
          newModel.orderQuantityForRevivedKg += completeYear.orderQuantityForRevivedKg;
          newModel.newKg += completeYear.newKg;
          newModel.revivedKg += completeYear.revivedKg;

          completeYear.tooltipDataNew.forEach((tooltipDataNew) => {
            tooltipDataNewList.push(tooltipDataNew);
          });

          completeYear.tooltipDataRevived.forEach((tooltipDataNew) => {
            tooltipDataRevivedList.push(tooltipDataNew);
          });
        });

        newModel.tooltipDataNew = this._mergeDataTooltip(tooltipDataNewList);
        newModel.tooltipDataRevived = this._mergeDataTooltip(tooltipDataRevivedList);

        filteredData.push(newModel);
      });
      // Note: sort data from oldest to newest
      filteredData = filteredData.sort((a, b) => a.year - b.year);
    } else {
      filteredData = [];
    }

    return filteredData;
  }

  _createDataResultCategory(emissionsByType) {
    const emissionsData = this._mergeData([...emissionsByType.emissionsData]);

    this._updateSavedEmissions();

    this._dataResultCategory = {
      datasets: [
        {
          label: 'New',
          data: emissionsData.map((x) => {
            return {
              y: x.newKg,
              x: x.label,
              orderQuantityForNewKg: x.orderQuantityForNewKg,
              tooltipText: x.tooltipDataNew,
            };
          }),
          backgroundColor: ['rgb(224, 228, 234)'],
          hoverBackgroundColor: ['rgb(224, 228, 234)'],
        },
        {
          label: 'Revived',
          data: emissionsData.map((x) => {
            return {
              y: x.revivedKg,
              x: x.label,
              orderQuantityForRevivedKg: x.orderQuantityForRevivedKg,
              tooltipText: x.tooltipDataRevived,
            };
          }),
          backgroundColor: ['rgb(255, 255, 255)'],
          hoverBackgroundColor: ['rgb(255, 255, 255)'],
        },
      ],
    };
  }

  _fillMissingMonths(data) {
    const year = data[0].year ? data[0].year : new Date().getFullYear();

    return monthList.map((label, index) => {
      const x = data.find((x) => x.month === index + 1);

      if (x) {
        return x;
      }
      return {
        label,
        year,
        orderQuantityForNewKg: 0,
        orderQuantityForRevivedKg: 0,
        newKg: 0,
        revivedKg: 0,
        tooltipDataNew: [],
        tooltipDataRevived: [],
      };
    });
  }

  _createDataResultPeriod(emissionsByDate) {
    let emissionsData = this._mergeData([...emissionsByDate.emissionsData]);

    if (emissionsData[0]) {
      if (isNaN(emissionsData[0].label) && !emissionsData[0].label.trim() !== '') {
        emissionsData = this._fillMissingMonths(emissionsData);
      }
    }
    this._updateSavedEmissions();

    this._dataResultPeriod = {
      datasets: [
        {
          label: 'New',
          data: emissionsData.map((x) => {
            return { y: x.newKg, x: x.label, tooltipText: x.tooltipDataNew };
          }),
          backgroundColor: ['rgb(224, 228, 234)'],
          hoverBackgroundColor: ['rgb(224, 228, 234)'],
        },
        {
          label: 'Revived',
          data: emissionsData.map((x) => {
            return { y: x.revivedKg, x: x.label, tooltipText: x.tooltipDataRevived };
          }),
          backgroundColor: ['rgb(255, 255, 255)'],
          hoverBackgroundColor: ['rgb(255, 255, 255)'],
        },
      ],
    };
  }

  _updateSavedEmissions() {
    const postFix = `&nbsp;kg`;

    let newTotal = 0;
    this._selectedYearSet.forEach((year) => {
      const value = this._kgSavedPerYear[year];
      newTotal += value;
    });

    this._chartTotalValue.innerHTML = newTotal + postFix;
  }

  /**
   * returns mocked data when in isDeveloperMode
   * @returns {Promise<any|{}>}
   * @private
   */
  async _fetchData() {
    const emptyResponse = {};
    const dataUrl = isDeveloperMode
      ? `/mock/data/co2-chart.json`
      : `${this._apiEndpoint}?language=${this._language}`;

    try {
      const response = await fetch(dataUrl);
      if (response.ok) {
        return await response.json();
      }
      throw new Error(`${response.status}: ${response.statusText} for ${response.url}`);
    } catch (e) {
      return emptyResponse;
    }
  }

  async _createEmissionChart() {
    const data = await this._fetchData();

    const { emissionsByType, emissionsByDate, kgSavedPerYear } = data;

    this._emissionsByType = emissionsByType;
    this._emissionsByDate = emissionsByDate;

    // Note: check for data
    if (!emissionsByType || !emissionsByDate) {
      // Note: Hide the 'Weergave' buttons
      this._btnCategory.style.visibility = 'hidden';
      this._btnPeriod.style.visibility = 'hidden';
      this._showMessage(true, `Er is iets fout gegaan!`);
      throw new Error(`No emissions found for 'emissionsByType' or 'emissionsByDate'`);
    }

    this._kgSavedPerYear = kgSavedPerYear;
    this._yearList = this._showByCategory ? emissionsByType.years : emissionsByDate.years;

    // Note: sort data from oldest to newest
    this._yearList = this._yearList.sort((a, b) => a - b);
    const activeYear = this._yearList[this._yearList.length - 1]
      ? this._yearList[this._yearList.length - 1]
      : new Date().getFullYear();
    // Note: initialize the _selectedYearSet
    this._selectedYearSet.push(activeYear);
    this._initYearButtons(activeYear);

    // Note: activate chart
    if (this._showByCategory) this._btnCategory.click();
    else this._btnPeriod.click();
  }

  _showMessage(showMessage, messageText = '') {
    if (showMessage) {
      this._messageWrapper.classList.add('active');
      this._messageWrapper.innerHTML = messageText;
    } else {
      this._messageWrapper.classList.remove('active');
    }
  }

  _initYearButtons(activeYear) {
    const filterButtonClass = 'button button--diapositive diapositive--light';

    this._yearList.forEach((year) => {
      const yearButton = document.createElement('button');
      yearButton.innerText = year;
      yearButton.className = filterButtonClass;
      if (year === activeYear) {
        yearButton.classList.add('active');
      }
      this._yearButtonWrapper.appendChild(yearButton);

      yearButton.addEventListener('click', (e) => {
        e.preventDefault();

        const yearIndex = this._selectedYearSet.indexOf(year);
        if (yearIndex !== -1) {
          this._selectedYearSet.splice(yearIndex, 1);
        } else {
          this._selectedYearSet.push(year);
        }
        this._selectedYearSet.sort((a, b) => {
          return b - a;
        });

        if (!this._selectedYearSet.length) {
          this._showMessage(true, `Er is geen 'Jaar' selectie meer actief!`);
        } else {
          this._showMessage(false);
        }

        yearButton.classList.toggle('active');

        this._rebuildSelectedChart();
      });
    });
  }

  _createIcon(icon) {
    return `<svg class="icon"><use xlink:href="/static/template-ahrend/img/sprite.svg#${icon}"/></svg>`;
  }

  _initTooltip(context, type) {
    const TOOLTIP_ID = 'chartjs-tooltip';
    const tooltipModel = context.tooltip;

    // Tooltip Element
    let tooltipEl = document.getElementById(TOOLTIP_ID);

    // Create element on first render
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = TOOLTIP_ID;
      tooltipEl.innerHTML = `<div id="tooltipBodyArea" class="arl-tooltip__body"></div>`;
      document.body.appendChild(tooltipEl);
    }

    // Hide if no tooltip
    if (tooltipModel.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }

    // Set caret Position
    tooltipEl.classList.add('arl-tooltip', 'arl-tooltip--co2');
    tooltipEl.classList.remove('above', 'below', 'no-transform');
    if (tooltipModel.yAlign) {
      tooltipEl.classList.add(tooltipModel.yAlign);
    } else {
      tooltipEl.classList.add('no-transform');
    }

    // Set Text
    if (tooltipModel.body) {
      const tooltipBodyArea = tooltipEl.querySelector('#tooltipBodyArea');

      let tooltipIcon = iconList.find((x) => x.id === tooltipModel.title[0]);
      const innerTooltip = [];

      if (type === 'category') {
        if (tooltipIcon) {
          innerTooltip.push(
            `<div class="arl-tooltip__icon">${this._createIcon(tooltipIcon.icon)}</div>`
          );
        }
      }

      const tooltipValueList = tooltipModel.dataPoints[0].raw.tooltipText;

      tooltipValueList.forEach((value) => {
        innerTooltip.push(`<div class="arl-tooltip__data-row">`);
        if (type === 'period') {
          tooltipIcon = iconList.find((x) => x.id === value.label);
          if (tooltipIcon) {
            innerTooltip.push(
              `<span class="arl-tooltip__icon--sm">${this._createIcon(tooltipIcon.icon)}</span>`
            );
          }
        }
        innerTooltip.push(`${value.count} ${value.label}<br>${value.kg} kg CO2`);
        innerTooltip.push(`</div>`);
      });

      if (tooltipBodyArea) {
        tooltipBodyArea.innerHTML = innerTooltip.join('');
      }
    }

    const position = context.chart.canvas.getBoundingClientRect();

    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left = `${position.left + window.scrollX + tooltipModel.caretX}px`;
    tooltipEl.style.top = `${position.top + window.scrollY + tooltipModel.caretY}px`;
    tooltipEl.style.pointerEvents = 'none';
  }

  _initDataLabel(dataItem) {
    return dataItem.y > 0 ? `${dataItem.y} kg` : '';
  }

  _initChartCategory(chart, data) {
    this._chart1 = new Chart(chart, {
      type: 'bar',
      plugins: [ChartDataLabels, htmlLegendPlugin],
      data,
      options: {
        plugins: {
          title: {
            display: false,
          },
          htmlLegend: {
            // ID of the container to put the legend in
            containerID: 'legendCategory',
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'center',
            align: 'center',
            color: '#4A566B',
            font: {
              size: 14,
              weight: 400,
            },
            formatter: (dataItem) => {
              return this._initDataLabel(dataItem);
            },
          },
          tooltip: {
            enabled: false,
            external: (context) => {
              return this._initTooltip(context, 'category');
            },
          },
        },
        responsive: true,
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false,
            },
            ticks: {
              color: '#667894',
              font: {
                size: 14,
              },
            },
          },
          y: {
            stacked: true,
            display: false,
          },
        },
      },
    });
  }

  _initChartPeriod(chart, data) {
    this._chart2 = new Chart(chart, {
      type: 'bar',
      plugins: [ChartDataLabels, htmlLegendPlugin],
      data,
      options: {
        plugins: {
          title: {
            display: false,
          },
          htmlLegend: {
            // ID of the container to put the legend in
            containerID: 'legendPeriod',
          },
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'center',
            align: 'center',
            color: '#4A566B',
            font: {
              size: 14,
              weight: 400,
            },
            formatter: (dataItem) => {
              return this._initDataLabel(dataItem);
            },
          },
          tooltip: {
            enabled: false,
            external: (context) => {
              return this._initTooltip(context, 'period');
            },
          },
        },
        responsive: true,
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false,
            },
            ticks: {
              color: '#667894',
              font: {
                size: 14,
              },
            },
          },
          y: {
            stacked: true,
            display: false,
          },
        },
      },
    });
  }
}

export default ChartNewRevived;
